import React from 'react';
import {
  compose,
  pure,
  branch,
  renderNothing,
  withState,
  withHandlers,
  withProps,
  lifecycle
} from 'recompose';
import { format } from 'date-fns';

import { getFile } from '../../../utils/resources';
import { TabHorizontal } from '../../core/TabsHorizontal';
import NoMenuWeekly from './NoMenuWeekly';
import { MenuDia, Allergies, ReservarMesa } from '../../../../assets/images';
import {
  StyledBoxDownWeekly,
  StyledIconAllergies,
  StyledMenuWellnessWeekly,
  StyledBookTable
} from './style';

import {
  StyledTitleWidget,
  StyledBoxWeek,
  StyledBoxSuperior,
  StyledTabsHorizontal,
  StyledDate,
  StyledBoxGeneral,
  StyleBoxWrapper,
  StyledBoxDay,
  StyledWrapperNoMenu
} from './styleMenuWeekly';

import MenuDay from './MenuDay';
import MenuObjetive from './MenuObjetive';
import Icon from '../../core/Icon';

const MenuWeekly = ({
  menus,
  allergensUrl,
  activeTab,
  changeTab,
  wellnessMenuUrl
}) => (
  <StyledBoxWeek>
    <StyledTitleWidget
      title="Menú del día"
      type="menuofday"
      icon={MenuDia}
      small
    />

    {menus.length !== 0 ? (
      <React.Fragment>
        <StyledBoxSuperior>
          <StyledTabsHorizontal
            activeIndex={activeTab}
            onClickArrow={changeTab}
            withButtons
          >
            {menus.map((item, index) => (
              <TabHorizontal
                key={item.menuDate}
                id={`menu-${index}`}
                active={index === activeTab}
                clicked={() => changeTab(index)}
                withButtons
              >
                <StyledDate format="dddd DD">{item.menuDate}</StyledDate>
              </TabHorizontal>
            ))}
          </StyledTabsHorizontal>
          <StyledBoxGeneral>
            <StyleBoxWrapper activeIndex={activeTab}>
              {menus.map(item => (
                <StyledBoxDay key={item.menuDate}>
                  <MenuDay weekly {...item} />
                  {item.menuWellness && (
                    <StyledMenuWellnessWeekly>
                      <MenuObjetive
                        menu={item.menuWellness}
                        wellnessMenuUrl={wellnessMenuUrl}
                        weekly
                      />
                    </StyledMenuWellnessWeekly>
                  )}
                </StyledBoxDay>
              ))}
            </StyleBoxWrapper>
          </StyledBoxGeneral>
        </StyledBoxSuperior>
        <StyledBoxDownWeekly>
          <StyledBookTable
            href="http://a3netpre/comercial/atresmil/servicios/turnosComedor.jsf"
            target="_blank"
            rel="noopener noreferrer"
            className="black"
          >
            Turnos comedor
          </StyledBookTable>
          <StyledBookTable
            href="http://a3netpre/comercial/atresmil/servicios/reservasDia.jsf"
            target="_blank"
            rel="noopener noreferrer"
            className="black"
          >
            Reservas del día
          </StyledBookTable>
          <StyledBookTable
            href="http://a3netpre/comercial/atresmil/servicios/misReservas.jsf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon className="icon-reserv" size="m" svg={ReservarMesa} />
            Reserva tu mesa
          </StyledBookTable>
          {allergensUrl && (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a
              className="alergenos"
              href={getFile(allergensUrl)}
              target="_blank"
              title="alérgenos"
            >
              <StyledIconAllergies size="l" svg={Allergies} />
            </a>
          )}
        </StyledBoxDownWeekly>
      </React.Fragment>
    ) : (
      <StyledWrapperNoMenu>
        <NoMenuWeekly />
      </StyledWrapperNoMenu>
    )}
  </StyledBoxWeek>
);

const getIndexMenuToday = menus =>
  menus.findIndex(menu => menu.menuDate === format(new Date(), 'YYYY-MM-DD'));

export default compose(
  branch(({ menus }) => !menus, renderNothing),
  withProps(({ menus }) => ({ size: menus.length - 1 })),
  withState('activeTab', 'setActiveTab', 0),
  withHandlers({
    changeTab: ({ setActiveTab, size }) => index => {
      let value;

      if (index < 0) {
        value = 0;
      } else if (index >= size) {
        value = size;
      } else {
        value = index;
      }

      return setActiveTab(value);
    }
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const { changeTab, menus } = this.props;

      if (nextProps.menus.length > menus.length) {
        changeTab(getIndexMenuToday(nextProps.menus));
      }
    },
    componentDidMount() {
      const { changeTab, menus } = this.props;

      if (menus.length) {
        changeTab(getIndexMenuToday(menus));
      }
    }
  }),
  pure
)(MenuWeekly);
